import { render, staticRenderFns } from "./VideoComp.vue?vue&type=template&id=ce494e1e&scoped=true&"
import script from "./VideoComp.vue?vue&type=script&lang=js&"
export * from "./VideoComp.vue?vue&type=script&lang=js&"
import style0 from "./VideoComp.vue?vue&type=style&index=0&id=ce494e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce494e1e",
  null
  
)

component.options.__file = "VideoComp.vue"
export default component.exports